exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1Wxo2{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:baseline;font-size:16px;line-height:1.45;font-weight:700;color:#000;-webkit-box-flex:0;-ms-flex:0 0 130px;flex:0 0 130px;text-align:right;-ms-flex-item-align:end;align-self:end;white-space:nowrap;height:28px}._1Wxo2 .neaqJ{font-size:12px}.NIc0Q{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:5px}._3kZ7g{position:relative;display:inline-block;background-color:transparent;padding:2px 5px;margin-top:-2px;color:#000}._2u8ZE{background-color:#ffeb3b}.xDBja{font-weight:700;display:inline-block;font-size:17px;padding:2px 5px;border-radius:2px;color:#000}._1mhV0{position:relative;font-size:15px;color:#111;background:none;margin-top:1px;font-weight:400}._3kZ7g:not(._2u8ZE):not(.xDBja)~._1mhV0{top:-5px}._2WmuS{z-index:5}._1SKeb{text-align:right;width:100%}._1GrBe{margin-right:28px}._1Wxo2 input{padding:5px 2px;border-radius:2px;height:24px;line-height:30px;border:1px solid #ccc;outline:none;font-size:16px}", ""]);

// exports
exports.locals = {
	"price": "_1Wxo2",
	"place": "neaqJ",
	"priceItem": "NIc0Q",
	"priceVal": "_3kZ7g",
	"emphasizePrice": "_2u8ZE",
	"topPrice": "xDBja _2u8ZE",
	"secondaryPrice": "_1mhV0",
	"priceValueBlock": "_2WmuS",
	"editInput": "_1SKeb",
	"marginRight": "_1GrBe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/PriceBlock/Price.css
// module id = 1900
// module chunks = 1 17 18 19 37